export * from './getRobotIcon';
